// One-shot splash. Decides once on module load whether to show.
// Rendered as a component (returns null or the splash) so it slots
// into the existing tree, but contains no React state.

import type { JSX } from "react";
import { useT } from "@/shared/i18n";

const STORAGE_KEY = "eurostyle_splash_shown";

function shouldShow(): boolean {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") return false;
    sessionStorage.setItem(STORAGE_KEY, "1");
    return true;
  } catch {
    if (import.meta.env.DEV) console.warn("[splash] sessionStorage access failed");
    return true;
  }
}

const SHOW = shouldShow();

export function Splash(): JSX.Element | null {
  const { t } = useT();
  if (!SHOW) return null;
  return (
    <div className="splash" aria-hidden="true">
      <div className="splash-logo">{t("splash.brand")}</div>
    </div>
  );
}
